'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Loadable from 'UIComponents/decorators/Loadable';
import UIButton from 'UIComponents/button/UIButton';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';

function langKey(key) {
  return `utils.makeAsyncUtils.${key}`;
}

const AsyncComponentRetry = ({
  retry
}) => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    illustrationProps: {
      width: '100'
    },
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: langKey('retry.title')
    }),
    children: /*#__PURE__*/_jsx(UIButton, {
      onClick: retry,
      size: "xs",
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: langKey('retry.message')
      })
    })
  });
};

AsyncComponentRetry.propTypes = {
  retry: PropTypes.func.isRequired
};

const AsyncComponentReload = () => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    illustrationProps: {
      width: '100'
    },
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: langKey('reload.title')
    }),
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: langKey('reload.message')
    })
  });
};

export const makeAsyncComponent = (loader, {
  containerStyles,
  delay = 500,
  maxRetries = 1
} = {}) => {
  let retries = 0;
  return Loadable({
    ErrorComponent: props => {
      let ErrorComponent = null;

      if (retries >= maxRetries) {
        ErrorComponent = /*#__PURE__*/_jsx(AsyncComponentReload, {});
      } else {
        ErrorComponent = /*#__PURE__*/_jsx(AsyncComponentRetry, {
          retry: props.retry
        });
      }

      retries++;
      return /*#__PURE__*/_jsx("div", {
        style: {
          height: '100%'
        },
        children: ErrorComponent
      });
    },
    LoadingComponent: ({
      pastDelay
    }) => {
      return pastDelay ? /*#__PURE__*/_jsx("div", {
        style: Object.assign({
          height: '100%'
        }, containerStyles),
        children: /*#__PURE__*/_jsx(UILoadingOverlay, {
          contextual: true
        })
      }) : null;
    },
    delay,
    loader
  });
};